<template>
  <div class="ui grid">
    <div
      v-for="(button, i) in buttons"
      :key="`button-${i}`"
      :class="columnClass"
    >
      <slot name="button" :button="button">
        <button class="ui fluid button" @click="button.method">{{ button.text }}</button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonGrid',
  props: ['buttons', 'columnWidth'],
  computed: {
    columnClass() {
      return this.columnWidth ? `${this.columnWidth} column` : 'four wide computer eight wide tablet column';
    },
  },
};
</script>
